//
//
//
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';

Swiper.use([Pagination, Navigation, Autoplay, EffectFade]);

import 'swiper/swiper-bundle.css';

const swiper_logos = () => {
	const swiper_sliders = document.querySelectorAll('.swiper-logos');
	swiper_sliders.forEach((slider, i) => {
		new Swiper(slider, {
			loop: true,
			spaceBetween: 60,
			speed: 1000,
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			modules: [Autoplay],
			// slidesPerView: 4,
			// centeredSlides: 'true',
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1280: {
					slidesPerView: 4,
				},
			},
		});
	});
};
window.addEventListener('DOMContentLoaded', swiper_logos);


const swiper_news = () => {
	let swiper_slider = document.querySelectorAll('.swiper-news');
	// let pagination = document.querySelectorAll('.swiper-news .swiper-pagination');
	swiper_slider.forEach((slider, i) => {
		const swiper = new Swiper(slider, {
			direction: 'horizontal',
			loop: true,
			spaceBetween: 60,
			slidesPerView: 1,
			// speed: 1000,
			// autoplay: {
			// 	delay: 2500,
			// 	disableOnInteraction: false,
			// },
			modules: [Pagination, Autoplay],
			pagination: {
				el: ".swiper-pagination",
				clickable: true
			},
		});
	});
};
window.addEventListener('DOMContentLoaded', swiper_news);
